/* eslint-disable */
import React, { useEffect } from 'react';
import { t } from '@web-solutions/module-localization';
import Analytics from '@web-solutions/module-analytics';
import { useRemoteConfig } from 'core/hooks/use-remote-config';
import { useStore } from 'src/onboarding/store/store';
import { getPwaUrlForOnboarding } from 'src/onboarding/helpers/getPwaUrl';
import { requestHandoffCode, buildAppUrlWithHandoff } from 'src/onboarding/helpers/pwaHandoff';
import styles from './style.module.scss';

// Let the confirmation be read before the app takes over.
const REDIRECT_DELAY_MS = 1800;

function Page() {
  const { redirectToPwa } = useRemoteConfig() as any;
  const authTokens = useStore((s: any) => s.authTokens);

  useEffect(() => {
    Analytics.trackEvent('hairstyleSuccess', 'view');
  }, []);

  // Autologin handoff into the PWA, same contract as the upsale-dynamic screen:
  // exchange the funnel's accessToken for a one-time code and hand it to the app
  // in the URL fragment (`#handoff=<code>`), which the PWA redeems instead of
  // asking for an email code. Best-effort — without a code the app opens on its
  // normal login, and with the flag off (or no tokens) the user simply stays on
  // this screen.
  useEffect(() => {
    if (!redirectToPwa || !authTokens?.accessToken) {
      return;
    }

    let cancelled = false;

    const timer = window.setTimeout(async () => {
      const code = await requestHandoffCode(authTokens.accessToken);

      if (cancelled) {
        return;
      }

      Analytics.trackEvent('hairstyleSuccess', 'pwaRedirect', { autologin: !!code });
      window.location.href = buildAppUrlWithHandoff(getPwaUrlForOnboarding(), code);
    }, REDIRECT_DELAY_MS);

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [redirectToPwa, authTokens]);

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>{t('hairstyleSuccess.title')}</h1>
      <p className={styles.subtitle}>{t('hairstyleSuccess.subtitle')}</p>
    </div>
  );
}

export default Page;
